'use client'

import Head from 'next/head'
import { useCompanyContext } from '@/lib/providers/CompanyProvider'
import { addRGBToHex } from '@/lib/utils/script'
import { useMemo } from 'react'

const IMAGE_TYPES = {
  ico: 'image/x-icon',
  png: 'image/png',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  webp: 'image/webp',
  gif: 'image/gif',
  svg: 'image/svg+xml',
}

const CustomStyles = () => {
  const { main_color: primaryNormal, company_favicon, company_og, name } = useCompanyContext()

  const { primaryStrong, primaryHeavy } = useMemo(() => {
    return {
      primaryStrong: primaryNormal ? addRGBToHex(primaryNormal, 0, -8, -20) : '#005eeb',
      primaryHeavy: primaryNormal ? addRGBToHex(primaryNormal, 0, -18, -46) : '#0054d1',
    }
  }, [primaryNormal])

  const { faviconHref, faviconType } = useMemo(() => {
    // 파일 확장자로 타입 지정 (image/x-icon, image/png, image/jpeg...)
    const extension = company_favicon?.file_path?.split('.').pop()

    return {
      faviconHref: company_favicon?.file_path,
      faviconType: IMAGE_TYPES[extension as keyof typeof IMAGE_TYPES],
    }
  }, [company_favicon])

  const { ogType, ogTitle, ogUrl, ogImage } = useMemo(() => {
    return {
      ogType: 'website',
      ogTitle: name,
      ogUrl: window.location.origin,
      ogImage: company_og?.file_path,
    }
  }, [name, company_og])

  return (
    <>
      <Head>
        {name && <title>{name} 관리자 페이지</title>}
        {company_favicon && (
          <>
            <link rel="icon" href={faviconHref} type={faviconType} />
            <link rel="shortcut icon" href={faviconHref} type={faviconType} />
            <link rel="apple-touch-icon" href={faviconHref} type={faviconType} />
            <link rel="apple-touch-icon-precomposed" href={faviconHref} type={faviconType} />
            <link rel="apple-touch-icon-precomposed" href={faviconHref} type={faviconType} />
          </>
        )}
        {company_og && (
          <>
            <meta property="og:type" content={ogType} />
            <meta property="og:title" content={ogTitle} />
            <meta property="og:url" content={ogUrl} />
            <meta property="og:image" content={ogImage} />
          </>
        )}
      </Head>

      {primaryNormal && (
        <>
          <style>
            {`:root {
        --Primary-Normal: ${primaryNormal};
        --Primary-Normal-10: ${primaryNormal}1A;
        --Primary-Normal-20: ${primaryNormal}33;
        --Primary-Normal-30: ${primaryNormal}4D;
        --Primary-Normal-40: ${primaryNormal}66;
        --Primary-Normal-50: ${primaryNormal}80;
        --Primary-Normal-60: ${primaryNormal}99;
        --Primary-Normal-70: ${primaryNormal}B3;
        --Primary-Normal-80: ${primaryNormal}CC;
        --Primary-Normal-90: ${primaryNormal}E5;
        --Primary-Normal-100: ${primaryNormal}FF;

        --Primary-Strong: ${primaryStrong};
        --Primary-Heavy: ${primaryHeavy};
      }`}
          </style>
        </>
      )}
    </>
  )
}

export default CustomStyles
